module.exports = __webpack_public_path__ + "static/media/25.b4b7d4d3.wav";